/*
 * @Author: 刘小博
 * @Date: 2023-02-07 14:43:29
 * @LastEditTime: 2023-04-19 19:09:39
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\behavior-manage\system-settings\modules\systemSettingRouter.js
 * 系统设置
 */
import store from '@/store'
import { loginDetail } from '@/api/login'
import { getNavigationt } from '@/api/common'
const systemSettingRouter = [
  // 行为管理 功能模块配置
  {
    path: '/behaviorManage/functionModuleDeploy',
    name: 'functionModuleDeploy',
    component: () =>
      // import(
      //   /*webpackChunkName:"functionModuleDeploy" */
      //   '@/views/behaviorManage/functionModuleDeploy.vue'
      // ),
      import(
        /*webpackChunkName:"functionModuleDeploy" */
        '@/views/behavior-manage/system-settings/functional-module/Page.vue'
      ), //// 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '功能模块配置'
    }
  },
  // 档案操作配置
  {
    path: '/behaviorManage/client-config-setting',
    name: 'clientConfigSetting',
    component: () =>
      // import(
      //   /*webpackChunkName:"ClientConfigSetting" */
      //   '@/views/behaviorManage/ClientConfigSetting.vue'
      // ),
      import(
        /*webpackChunkName:"ClientConfigSetting" */
        '@/views/behavior-manage/system-settings/functional-module/file-operation/Page.vue'
      ), //// 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '档案操作配置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },

  // 档案审批设置
  {
    path: '/behaviorManage/approval-list/:meta_type',
    name: 'behaviorManageApprovalList',
    component: () =>
      // import(
      //   /*webpackChunkName:"functionModuleDeploy" */
      //   '@/views/behaviorManage/approval/List.vue'
      // ),
      import(
        /*webpackChunkName:"functionModuleDeploy" */
        '@/views/behavior-manage/system-settings/functional-module/file-approval/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      isMoreMeta: true,
      1: {
        title: '档案审批设置',
        breadcrumb: [
          {
            title: '功能模块配置',
            name: 'functionModuleDeploy'
          }
        ]
      },
      2: {
        title: '活动审批设置',
        breadcrumb: [
          {
            title: '审批设置',
            name: 'behaviorManageApprovalIndex'
          }
        ]
      }
    }
  },
  // 创建档案审批流程
  {
    path: '/behaviorManage/approval-flow/:id/:meta_type',
    name: 'behaviorManageApprovalFlow',
    component: () =>
      // import(
      //   /*webpackChunkName:"functionModuleDeploy" */
      //   '@/views/behaviorManage/ApprovalFlow.vue'
      // ),
      import(
        /*webpackChunkName:"functionModuleDeploy" */
        '@/views/behavior-manage/system-settings/functional-module/file-approval/Edit.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '审批流程',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 档案地址管理
  {
    path: '/behaviorManage/client-multiple-address',
    name: 'clientMultipleAddress',
    component: () =>
      // import(
      //   /*webpackChunkName:"clientMultipleAddress" */
      //   '@/views/behaviorManage/ClientMultipleAddress.vue'
      // ),
      import(
        /*webpackChunkName:"clientMultipleAddress" */
        '@/views/behavior-manage/system-settings/functional-module/file-address-manage/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '档案地址管理',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 省份列表设置
  {
    path: '/behaviorManage/province-list-setting',
    name: 'behaviorManageProvinceListSetting',
    component: () =>
      // import(
      //   /*webpackChunkName:"functionModuleDeploy" */
      //   '@/views/behaviorManage/ProvinceListSetting'
      // ),
      import(
        /*webpackChunkName:"functionModuleDeploy" */
        '@/views/behavior-manage/system-settings/functional-module/province-list-setting/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '省份列表',
      breadcrumb: [
        {
          title: '功能模版设置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 行为管理 拜访任务属性配置
  {
    path: '/behaviorManage/attribute-temporary-setting',
    name: 'behaviorManageAttributeTemporarySetting',
    component: () =>
      // import(
      //   /*webpackChunkName:"functionModuleDeploy" */
      //   '@/views/behaviorManage/AttributeTemporarySetting.vue'
      // ),
      import(
        /*webpackChunkName:"functionModuleDeploy" */
        '@/views/behavior-manage/system-settings/functional-module/visit-task-attribute/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '拜访任务属性配置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 行为管理 模版列表
  {
    path: '/behaviorManage/functionModuleDeploy/templateList/:meta_type',
    name: 'functionModuleDeployTemplateList',
    component: () =>
      // import(
      //   /*webpackChunkName:"functionModuleDeploy" */
      //   '@/views/behaviorManage/templateList.vue'
      // ),
      import(
        /*webpackChunkName:"functionModuleDeploy" */
        '@/views/behavior-manage/system-settings/functional-module/visit-template/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      isMoreMeta: true,
      1: {
        title: '拜访模版',
        breadcrumb: [
          {
            title: '功能模块配置',
            name: 'functionModuleDeploy'
          }
        ]
      },
      2: {
        title: '协访模版',
        breadcrumb: [
          {
            title: '功能模块配置',
            name: 'functionModuleDeploy'
          }
        ]
      },
      3: {
        title: '活动形式配置',
        breadcrumb: [
          {
            title: '功能模块配置',
            name: 'functionModuleDeploy'
          }
        ]
      }
    },
    async beforeEnter(to, from, next) {
      if (
        store.state.funcModuleArray &&
        store.state.funcModuleArray.length > 0
      ) {
        next()
      } else {
        await loginDetail(store.state.save_quarter_id).then((res) => {
          store.commit('SET_ACCOUNT_INFO', res.data)
          getNavigationt({
            quarter_id: res.data.quarterRow.quarter_id
          }).then((res) => {
            if (0 === res.status) {
              store.commit('setFuncModuleArray', res.data.funcModuleArray)
              store.commit('setModuleRow', res.data.moduleRow)
              next()
            }
          })
        })
      }
    }
  },
  // 行为管理 功能模版 新增模mg/projectReport/export版和编辑
  {
    path: '/behaviorManage/newlyTemplate/:meta_type/:id',
    name: 'behaviorManageNewlyTemplate',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageSe" */
      //   '@/views/behaviorManage/newlyTemplate.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageSe" */
        '@/views/behavior-manage/system-settings/functional-module/visit-template/Edit.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      isMoreMeta: true,
      1: {
        title: '新增模版',
        breadcrumb: [
          {
            title: '功能模块配置',
            name: 'functionModuleDeploy'
          },
          {
            title: '拜访模版',
            name: 'functionModuleDeployTemplateList'
          }
        ]
      },
      2: {
        title: '新增模版',
        breadcrumb: [
          {
            title: '功能模块配置',
            name: 'functionModuleDeploy'
          },
          {
            title: '协访模版',
            name: 'functionModuleDeployTemplateList'
          }
        ]
      },
      3: {
        title: '新增活动形式',
        breadcrumb: [
          {
            title: '功能模块配置',
            name: 'functionModuleDeploy'
          },
          {
            title: '活动形式配置',
            name: 'functionModuleDeployTemplateList'
          }
        ]
      }
    }
  },
  // 行为管理 功能模版 创建拜访模板
  {
    path: '/behaviorManage/create-call-template/:meta_type/:id',
    name: 'behaviorManageCreateCallTemplate',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageSe" */
      //   '@/views/behaviorManage/createCallTemplate.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageSe" */
        '@/views/behavior-manage/system-settings/functional-module/visit-template/AddCallTemplate.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '新增模版',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        },
        {
          title: '拜访模版',
          name: 'functionModuleDeployTemplateList'
        }
      ]
    }
  },
  // 拜访对象设置
  {
    path: '/behaviorManage/visit-object-setting',
    name: 'visitObjectSetting',
    component: () =>
      // import(
      //   /*webpackChunkName:"VisitObjectSetting" */
      //   '@/views/behaviorManage/VisitObjectSetting.vue'
      // ),
      import(
        /*webpackChunkName:"VisitObjectSetting" */
        '@/views/behavior-manage/system-settings/functional-module/visit-object/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '拜访对象设置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },

  // 关键信息传达模版 列表 设置
  {
    path: '/behaviorManage/doctor-visit-template-list',
    name: 'behaviorManageDoctorVisitTemplateList',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageDoctorVisitTemplateList" */
      //   '@/views/behaviorManage/DoctorVisitTemplate/TemplateList.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageDoctorVisitTemplateList" */
        '@/views/behavior-manage/system-settings/functional-module/key-information-trans/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '关键信息传达模版设置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 新增关键信息传达模版
  {
    path: '/behaviorManage/new-KeyInfo-template/:id/:meta_type',
    name: 'behaviorManageNewKeyInfoTemplate',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageNewKeyInfoTemplate" */
      //   '@/views/behaviorManage/DoctorVisitTemplate/NewKeyInfoTemplate.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageNewKeyInfoTemplate" */
        '@/views/behavior-manage/system-settings/functional-module/key-information-trans/Add.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      isMoreMeta: true,
      1: {
        title: '新增关键信息传达模版',
        breadcrumb: [
          {
            title: '功能模块配置',
            name: 'functionModuleDeploy'
          },
          {
            title: '关键信息传达模版设置',
            name: 'behaviorManageDoctorVisitTemplateList'
          }
        ]
      },
      2: {
        title: '编辑关键信息传达模版',
        breadcrumb: [
          {
            title: '功能模块配置',
            name: 'functionModuleDeploy'
          },
          {
            title: '关键信息传达模版设置',
            name: 'behaviorManageDoctorVisitTemplateList'
          }
        ]
      }
    }
  },
  // 拜访客户类型设置
  {
    path: '/behaviorManage/visit-client-set',
    name: 'behaviorManageVisitClientSet',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageAmendRecord" */
      //   '@/views/behaviorManage/VisitClientSet.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageAmendRecord" */
        '@/views/behavior-manage/system-settings/functional-module/visit-customer-type/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '拜访客户类型设置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 学术推广材料
  {
    path: '/masterDataSystem/academic-popularize',
    name: 'masterDataSystemAcademicPopularize',
    component: () =>
      // import(
      //   /*webpackChunkName:"masterDataSystemAcademicPopularize" */
      //   '@/views/masterDataSystem/academic-popularize/AcademicPopularize.vue'
      // ),
      import(
        /*webpackChunkName:"masterDataSystemAcademicPopularize" */
        '@/views/behavior-manage/system-settings/functional-module/academic-promotional-materials/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '学术推广材料',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 添加推广材料
  {
    path: '/masterDataSystem/add-materials/:id/:meta_type',
    name: 'masterDataSystemAddMaterials',
    component: () =>
      // import(
      //   /*webpackChunkName:"masterDataSystemAddMaterials" */
      //   '@/views/masterDataSystem/academic-popularize/AddMaterials.vue'
      // ),
      import(
        /*webpackChunkName:"masterDataSystemAddMaterials" */
        '@/views/behavior-manage/system-settings/functional-module/academic-promotional-materials/Add.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      isMoreMeta: true,
      1: {
        title: '添加推广材料',
        breadcrumb: [
          {
            title: '功能模块配置',
            name: 'functionModuleDeploy'
          },
          {
            title: '学术推广材料',
            name: 'masterDataSystemAcademicPopularize'
          }
        ]
      },
      2: {
        title: '编辑推广材料',
        breadcrumb: [
          {
            title: '功能模块配置',
            name: 'functionModuleDeploy'
          },
          {
            title: '学术推广材料',
            name: 'masterDataSystemAcademicPopularize'
          }
        ]
      }
    }
  },
  // 行为管理 数据上报功能配置
  {
    path: '/behaviorManage/data-reporting',
    name: 'behaviorManageDataReporting',
    component: () =>
      // import(
      //   /*webpackChunkName:"abilityAnalysisTemplateSet" */
      //   '@/views/behaviorManage/dataReporting/index.vue'
      // ),
      import(
        /*webpackChunkName:"abilityAnalysisTemplateSet" */
        '@/views/behavior-manage/system-settings/functional-module/data-report/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '数据上报功能配置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 功能模版配置 处方单配置
  {
    path: '/behaviorManage/prescription-set',
    name: 'behaviorManagePrescriptionset',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOldHospitalSet" */
      //   '@/views/flowSystem/Prescriptionset.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageOldHospitalSet" */
        '@/views/behavior-manage/system-settings/functional-module/prescription-config/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '处方单配置',
      breadcrumb: [
        {
          title: '功能模版配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 功能模版配置 拜访目的配置
  {
    path: '/behaviorManage/visitPurpose',
    name: 'behaviorManageVisitPurpose',
    component: () =>
      import(
        /*webpackChunkName:"behaviorManageOldHospitalSet" */
        '@/views/behavior-manage/system-settings/functional-module/visit-purpose/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '拜访目的配置',
      breadcrumb: [
        {
          title: '功能模版配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },

  // 功能模版配置 标准话术配置
  {
    path: '/behaviorManage/wordsTechnique',
    name: 'behaviorManageWordsTechnique',
    component: () =>
      import(
        /*webpackChunkName:"behaviorManageWordsTechnique" */
        '@/views/behavior-manage/system-settings/functional-module/words-technique/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '标准话术配置',
      breadcrumb: [
        {
          title: '功能模版配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 活动形式配置
  {
    path: '/behaviorManage/activity-deploy/list',
    name: 'activityDeployList',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageWorkAttendance" */
      //   '@/views/behaviorManage/activity-deploy/list.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageWorkAttendance" */
        '@/views/behavior-manage/system-settings/functional-module/activity-form-config/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '活动形式配置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 添加编辑活动形式
  {
    path: '/behaviorManage/add-redact-modality/:id',
    name: 'AddRedactModality',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageWorkAttendance" */
      //   '@/views/behaviorManage/activity-deploy/AddRedactModality.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageWorkAttendance" */
        '@/views/behavior-manage/system-settings/functional-module/activity-form-config/Edit.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '新增活动形式',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        },
        {
          title: '活动形式配置',
          name: 'activityDeployList'
        }
      ]
    }
  },
  // 管理活动模版
  {
    path: '/behaviorManage/Management-activity-template',
    name: 'ManagementActivityTemplate',
    component: () =>
      // import(
      //   /*webpackChunkName:"ManagementActivityTemplate" */
      //   '@/views/behaviorManage/activity-deploy/ManagementActivityTemplate.vue'
      // ),
      import(
        /*webpackChunkName:"ManagementActivityTemplate" */
        '@/views/behavior-manage/system-settings/functional-module/activity-form-config/manage-activity/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '管理活动模版',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        },
        {
          title: '活动形式配置',
          name: 'activityDeployList'
        }
      ]
    }
  },

  // 新增活动模版
  {
    path: '/behaviorManage/add-redact-activity-template/:id',
    name: 'addRedactActivityTemplate',
    component: () =>
      // import(
      //   /*webpackChunkName:"addRedactActivityTemplate" */
      //   '@/views/behaviorManage/activity-deploy/addRedactActivityTemplate.vue'
      // ),
      import(
        /*webpackChunkName:"addRedactActivityTemplate" */
        '@/views/behavior-manage/system-settings/functional-module/activity-form-config/manage-activity/Add.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '新增活动模版',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        },
        {
          title: '活动形式配置',
          name: 'activityDeployList'
        },
        {
          title: '管理活动模版',
          name: 'ManagementActivityTemplate'
        }
      ]
    }
  },
  // 功能模版配置 自报内容配置
  {
    path: '/behaviorManage/self-report-content-config',
    name: 'behaviorManageSelfReportContentConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOldHospitalSet" */
      //   '@/views/behaviorManage/SelfReportContentConfig.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageOldHospitalSet" */
        '@/views/behavior-manage/system-settings/functional-module/self-report-content/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '自报内容配置',
      breadcrumb: [
        {
          title: '功能模版配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 功能模版配置 自报内容配置 操作记录 meta_type 1-药店 2-医院
  {
    path: '/behaviorManage/self-report-log/:meta_type',
    name: 'behaviorManageSelfReportLog',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOldHospitalSet" */
      //   '@/views/behaviorManage/SelfReportLog.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageOldHospitalSet" */
        '@/views/behavior-manage/system-settings/functional-module/self-report-content/OperationRecord.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '操作记录',
      breadcrumb: [
        {
          title: '功能模版配置',
          name: 'functionModuleDeploy'
        },
        {
          title: '自报内容配置',
          name: 'behaviorManageSelfReportContentConfig'
        }
      ]
    }
  },
  // 自报填写配置
  {
    path: '/behaviorManage/report-allocation',
    name: 'behaviorManageReportAllocation',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage" */
      //   '@/views/behaviorManage/ReportAllocation.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManage" */
        '@/views/behavior-manage/system-settings/functional-module/self-report-filling-authority/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '自报填写权限配置',
      breadcrumb: [
        {
          title: '功能模版配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 医生估量设置
  {
    path: '/behaviorManage/doctors-estimate-setting',
    name: 'behaviorManageDoctorsEstimateSetting',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage" */
      //   '@/views/behaviorManage/DoctorsEstimateSetting.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManage" */
        '@/views/behavior-manage/system-settings/functional-module/doctor-estimation-setting/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '医生估量设置',
      breadcrumb: [
        {
          title: '功能模版配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 数据上报配置（新）
  {
    path: '/behaviorManage/data-report-setting/page',
    name: 'behaviorManageDataReportSettingPage',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageDoctorsEstimatePage" */
      //   '@/views/behaviorManage/data-report-setting/Page'
      // ),
      import(
        /*webpackChunkName:"behaviorManageDoctorsEstimatePage" */
        '@/views/behavior-manage/system-settings/functional-module/new-data-report/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '数据上报配置（新）',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },

  // 新增 数据上报配置 id
  {
    path: '/behaviorManage/data-report-setting/add/:id',
    name: 'behaviorManageDataReportSettingAdd',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageDoctorsEstimatePage" */
      //   '@/views/behaviorManage/data-report-setting/Add'
      // ),
      import(
        /*webpackChunkName:"behaviorManageDoctorsEstimatePage" */
        '@/views/behavior-manage/system-settings/functional-module/new-data-report/Add.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '新增配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        },
        {
          title: '数据上报配置（新）',
          name: 'behaviorManageDataReportSettingPage'
        }
      ]
    }
  },
  // 审批 数据上报配置
  {
    path: '/behaviorManage/data-report-setting/approval/:id/:name',
    name: 'behaviorManageDataReportSettingApproval',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageDoctorsEstimatePage" */
      //   '@/views/behaviorManage/data-report-setting/Approval'
      // ),
      import(
        /*webpackChunkName:"behaviorManageDoctorsEstimatePage" */
        '@/views/behavior-manage/system-settings/functional-module/new-data-report/Approval.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '纯销自报 审批流设置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        },
        {
          title: '数据上报配置（新）',
          name: 'behaviorManageDataReportSettingPage'
        }
      ]
    }
  },
  // 行为管理 工作时间
  {
    path: '/behaviorManage/working-time',
    name: 'behaviorManageWorkingTime',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage4" */
      //   '@/views/behaviorManage/WorkingTime.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManage4" */
        '@/views/behavior-manage/system-settings/functional-module/working-hour/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '工作时间',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },

  // 行为管理 工作报告配置 日报
  {
    path: '/behaviorManage/work-report',
    name: 'behaviorManageWorkReport',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage2" */
      //   '@/views/behaviorManage/workReport/WorkReport.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManage2" */
        '@/views/behavior-manage/system-settings/functional-module/working-report/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '工作报告配置',
      breadcrumb: [
        {
          title: '功能模版设置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },

  // 工作报告配置模版 新增编辑
  {
    path: '/behaviorManage/work-template-add-redact/:meta_type/:id',
    name: 'behaviorManageWorkTemplateAddRedact',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageWorkTemplateAddRedact" */
      //   '@/views/behaviorManage/workReport/WorkTemplateAddRedact.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageWorkTemplateAddRedact" */
        '@/views/behavior-manage/system-settings/functional-module/working-report/Edit.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      isMoreMeta: true,
      1: {
        title: '新增模版',
        breadcrumb: [
          {
            title: '功能模版设置',
            name: 'functionModuleDeploy'
          },
          {
            title: '工作报告配置',
            name: 'behaviorManageWorkReport'
          }
        ]
      },
      2: {
        title: '编辑模版',
        breadcrumb: [
          {
            title: '功能模版设置',
            name: 'functionModuleDeploy'
          },
          {
            title: '工作报告配置',
            name: 'behaviorManageWorkReport'
          }
        ]
      }
    }
  },
  // 考勤标签配置
  {
    path: '/behaviorManage/attendance-label-set',
    name: 'behaviorManageAttendanceLabelSet',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageNewHospitalExploit" */
      //   '@/views/behaviorManage/AttendanceLabelSet.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageNewHospitalExploit" */
        '@/views/behavior-manage/system-settings/functional-module/attendance-tag-configuration/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '考勤标签配置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 医院开发  开发阶段
  {
    path: '/behaviorManage/new-hospital-exploit',
    name: 'behaviorManageNewHospitalExploit',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageNewHospitalExploit" */
      //   '@/views/behaviorManage/newHospital/NewHospitalExploit.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageNewHospitalExploit" */
        '@/views/behavior-manage/system-settings/functional-module/hospital-development/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '新医院开发配置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 医院开发 开发信息模版 -- 设置填报内容
  {
    path: '/behaviorManage/msg-template/:id/:meta_type/:department_ids/:department_name',
    // '/behaviorManage/msg-template/:id/:meta_type/:department_ids/:department_name/:isOneId',
    name: 'behaviorManageMsgTemplate',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageMsgTemplate" */
      //   '@/views/behaviorManage/newHospital/MsgTemplate.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageMsgTemplate" */
        '@/views/behavior-manage/system-settings/functional-module/hospital-development/MsgTemplate.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      isMoreMeta: true,
      1: {
        title: '添加开发模式',
        breadcrumb: [
          {
            title: '功能模块配置',
            name: 'functionModuleDeploy'
          },
          {
            title: '新医院开发配置',
            name: 'behaviorManageNewHospitalExploit'
          }
        ]
      },
      2: {
        title: '设置填报内容',
        breadcrumb: [
          {
            title: '功能模块配置',
            name: 'functionModuleDeploy'
          },
          {
            title: '新医院开发配置',
            name: 'behaviorManageNewHospitalExploit'
          }
        ]
      }
    }
  },

  // 新医院开发阶段配置
  {
    path: '/behaviorManage/phase-config/:template_id/:name',
    name: 'behaviorManagePhaseConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageMsgTemplate" */
      //   '@/views/behaviorManage/newHospital/PhaseConfig.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageMsgTemplate" */
        '@/views/behavior-manage/system-settings/functional-module/hospital-development/PhaseConfig.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '阶段配置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        },
        {
          title: '新医院开发配置',
          name: 'behaviorManageNewHospitalExploit'
        }
      ]
    }
  },
  // 考核配置设置
  {
    path: '/behaviorManage/assess-allocation',
    name: 'behaviorManageAssessAllocation',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageSetWeekly" */
      //   '@/views/behaviorManage/jiuxin/AssessAllocation.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageSetWeekly" */
        '@/views/behavior-manage/system-settings/functional-module/appraisal-configuration/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '考核配置设置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 考核配置设置 考核方案配置
  {
    path: '/behaviorManage/assessment-configuration/:id/:type/:title',
    name: 'behaviorManageAssessmentConfiguration',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageSetWeekly" */
      //   '@/views/behaviorManage/jiuxin/AssessmentConfiguration/index.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageSetWeekly" */
        '@/views/behavior-manage/system-settings/functional-module/appraisal-configuration/ApprasalScheme.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '考核方案配置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        },
        {
          title: '考核配置设置',
          name: 'behaviorManageAssessAllocation'
        }
      ]
    }
  },
  // 考核配置设置 考核方案配置 历史考核
  {
    path: '/behaviorManage/assessment-configuration/history/:id/:type/:title',
    name: 'behaviorManageAssessmentConfigurationHistory',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageSetWeekly" */
      //   '@/views/behaviorManage/jiuxin/AssessmentConfiguration/history.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageSetWeekly" */
        '@/views/behavior-manage/system-settings/functional-module/appraisal-configuration/HistoryAppraisal.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '历史考核',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        },
        {
          title: '考核配置设置',
          name: 'behaviorManageAssessAllocation'
        },
        {
          title: '考核方案配置',
          name: 'behaviorManageAssessmentConfiguration'
        }
      ]
    }
  },
  // 考核配置设置 考核方案配置 考核项配置
  {
    path: '/behaviorManage/assessment-configuration/detail/:id/:type/:title/:item_title/:assess_item_id',
    name: 'behaviorManageAssessmentConfigurationDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageSetWeekly" */
      //   '@/views/behaviorManage/jiuxin/AssessmentConfiguration/detail.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageSetWeekly" */
        '@/views/behavior-manage/system-settings/functional-module/appraisal-configuration/AppraisalItem.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '考核项配置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        },
        {
          title: '考核配置设置',
          name: 'behaviorManageAssessAllocation'
        },
        {
          title: '考核方案配置',
          name: 'behaviorManageAssessmentConfiguration'
        }
      ]
    }
  },

  // 敏感词管理A
  {
    path: '/flowSystem/sensitive-word-management',
    name: 'flowSystemSensitiveWordManagement',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage5" */
      //   '@/views/behaviorManage/SensitiveWordManagement.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManage5" */
        '@/views/behavior-manage/system-settings/functional-module/sensitive-word-management/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '敏感词管理',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 导入敏感词
  {
    path: '/flowSystem/import-sensitive-word',
    name: 'flowSystemImportSensitiveWord',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage5" */
      //   '@/views/behaviorManage/ImportSensitiveWord.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManage5" */
        '@/views/behavior-manage/system-settings/functional-module/sensitive-word-management/Import.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '导入敏感词',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        },
        {
          title: '敏感词管理',
          name: 'flowSystemSensitiveWordManagement'
        }
      ]
    }
  },
  // 功能模版配置 医院上量
  {
    path: '/behaviorManage/old-hospital-fun-set',
    name: 'behaviorManageOldHospitalfunset',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOldHospitalSet" */
      //   '@/views/flowSystem/OldHospitalfunset.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageOldHospitalSet" */
        '@/views/behavior-manage/system-settings/functional-module/hospital-volume/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '医院上量',
      breadcrumb: [
        {
          title: '功能模版配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // crm报表配置
  {
    path: '/behaviorManage/crmbehaviorstatements-config',
    name: 'crmBehaviorStatementsConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"CrmBehaviorStatementsConfig" */
      //   '@/views/behaviorManage/config/CrmBehaviorStatements'
      // ),
      import(
        /*webpackChunkName:"CrmBehaviorStatementsConfig" */
        '@/views/behavior-manage/system-settings/functional-module/crm-report/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: 'CRM报表配置',
      breadcrumb: [
        {
          title: '功能模版配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 功能模版配置 服务商准入权限配置
  {
    path: '/behaviorManage/service-provider-access-set',
    name: 'behaviorManageServiceProviderAccessSet',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOldHospitalSet" */
      //   '@/views/behaviorManage/ServiceProviderAccessSet.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageOldHospitalSet" */
        '@/views/behavior-manage/system-settings/functional-module/service-provider-access/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '服务商准入权限配置',
      breadcrumb: [
        {
          title: '功能模版配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 功能模版配置 筛选职位显示配置
  {
    path: '/behaviorManage/screening-jobs',
    name: 'behaviorManageScreeningJobs',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOldHospitalSet" */
      //   '@/views/behaviorManage/ScreeningJobs.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageOldHospitalSet" */
        '@/views/behavior-manage/system-settings/functional-module/filter-position-display/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '筛选职位显示配置',
      breadcrumb: [
        {
          title: '功能模版配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },

  // 行为管理 能力分析模版配置
  {
    path: '/behaviorManage/ability-analysis/template-set',
    name: 'abilityAnalysisTemplateSet',
    component: () =>
      // import(
      //   /*webpackChunkName:"abilityAnalysisTemplateSet" */
      //   '@/views/behaviorManage/abilityAnalysis/templateSet.vue'
      // ),
      import(
        /*webpackChunkName:"abilityAnalysisTemplateSet" */
        '@/views/behavior-manage/system-settings/functional-module/capability-analysis-template/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '能力分析模版配置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 行为管理 能力分析模版添加编辑模版
  {
    path: '/behaviorManage/ability-analysis/add-edit/:meta_type/:id',
    name: 'abilityAnalysisAddEdit',
    component: () =>
      // import(
      //   /*webpackChunkName:"abilityAnalysisAddEdit" */
      //   '@/views/behaviorManage/abilityAnalysis/addEdit.vue'
      // ),
      import(
        /*webpackChunkName:"abilityAnalysisAddEdit" */
        '@/views/behavior-manage/system-settings/functional-module/capability-analysis-template/Add.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      isMoreMeta: true,
      1: {
        title: '新增能力分析模版',
        breadcrumb: [
          {
            title: '功能模块配置',
            name: 'functionModuleDeploy'
          },
          {
            title: '能力分析模版配置',
            name: 'abilityAnalysisTemplateSet'
          }
        ]
      },
      2: {
        title: '编辑能力分析模版',
        breadcrumb: [
          {
            title: '功能模块配置',
            name: 'functionModuleDeploy'
          },
          {
            title: '能力分析模版配置',
            name: 'abilityAnalysisTemplateSet'
          }
        ]
      }
    }
  },
  // 招商作战地图模版配置 列表
  {
    path: '/behaviorManage/operationalMap/list',
    name: 'operationalMapList',
    component: () =>
      import(
        '@/views/behavior-manage/system-settings/functional-module/investment-battle-map/Page.vue'
      ), // 新迁移文件
    // import('@/views/behaviorManage/operationalMap/list.vue'),
    meta: {
      title: '招商作战地图模版配置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },
  // 招商作战地图模版配置 添加编辑
  {
    path: '/behaviorManage/operationalMap/addEdit/:battle_map_template_id',
    name: 'operationalMapaddEdit',
    component: () =>
      // import('@/views/behaviorManage/operationalMap/addEdit.vue'),
      import(
        '@/views/behavior-manage/system-settings/functional-module/investment-battle-map/Add.vue'
      ), // 新迁移文件
    meta: {
      title: '招商作战地图模版配置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        },
        {
          title: '招商作战地图模版配置',
          name: 'operationalMapList'
        }
      ]
    }
  },
  // 招商作战地图模版配置 导入数据
  {
    path: '/behaviorManage/operationalMap/import/:battle_map_template_id',
    name: 'operationalMapImport',
    component: () =>
      // import('@/views/behaviorManage/operationalMap/import.vue'),
      import(
        '@/views/behavior-manage/system-settings/functional-module/investment-battle-map/Import.vue'
      ), // 新迁移文件
    meta: {
      title: '导入数据',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        },
        {
          title: '招商作战地图模版配置',
          name: 'operationalMapList'
        }
      ]
    }
  },
  // 招商作战地图模版配置 导出数据
  {
    path: '/behaviorManage/operationalMap/export/:battle_map_template_id',
    name: 'operationalMapExport',
    component: () =>
      // import('@/views/behaviorManage/operationalMap/export.vue'),
      import(
        '@/views/behavior-manage/system-settings/functional-module/investment-battle-map/Export.vue'
      ), // 新迁移文件
    meta: {
      title: '导出数据',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        },
        {
          title: '招商作战地图模版配置',
          name: 'operationalMapList'
        }
      ]
    }
  },
  // 行为管理 移动端界面配置
  {
    path: '/behaviorManage/mobileTerminalDeploy',
    name: 'behaviorManageMobileTerminalDeploy',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage1" */
      //   '@/views/behaviorManage/mobileTerminalDeploy.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManage1" */
        '@/views/behavior-manage/system-settings/mobile-terminal-interface/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '移动端界面配置'
    },
    async beforeEnter(to, from, next) {
      if (
        store.state.funcModuleArray &&
        store.state.funcModuleArray.length > 0
      ) {
        next()
      } else {
        await loginDetail(store.state.save_quarter_id).then((res) => {
          store.commit('SET_ACCOUNT_INFO', res.data)
          getNavigationt({
            quarter_id: res.data.quarterRow.quarter_id
          }).then((res) => {
            if (0 === res.status) {
              store.commit('setFuncModuleArray', res.data.funcModuleArray)
              store.commit('setModuleRow', res.data.moduleRow)
              next()
            }
          })
        })
      }
    }
  },
  // 行为管理 CRM页面配置
  {
    path: '/behaviorManage/crmDeploy/:meta_type',
    name: 'behaviorManageCrmDeploy',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage1" */
      //   '@/views/behaviorManage/crmDeploy.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManage1" */
        '@/views/behavior-manage/system-settings/mobile-terminal-interface/crm-page-config/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      isMoreMeta: true,
      1: {
        title: '首页配置',
        breadcrumb: [
          {
            title: '移动端界面配置',
            name: 'behaviorManageMobileTerminalDeploy'
          }
        ]
      },
      2: {
        title: '仪表盘配置',
        breadcrumb: [
          {
            title: '移动端界面配置',
            name: 'behaviorManageMobileTerminalDeploy'
          }
        ]
      },
      3: {
        title: 'CRM页面配置',
        breadcrumb: [
          {
            title: '移动端界面配置',
            name: 'behaviorManageMobileTerminalDeploy'
          }
        ]
      },
      4: {
        title: '办公页面配置',
        breadcrumb: [
          {
            title: '移动端界面配置',
            name: 'behaviorManageMobileTerminalDeploy'
          }
        ]
      },
      5: {
        title: '报表中心配置',
        breadcrumb: [
          {
            title: '移动端界面配置',
            name: 'behaviorManageMobileTerminalDeploy'
          }
        ]
      },
      6: {
        title: '数据上报页面配置',
        breadcrumb: [
          {
            title: '移动端界面配置',
            name: 'behaviorManageMobileTerminalDeploy'
          }
        ]
      }
    }
  },
  // 操作日志 行为管理
  // meta_type -1 特殊客户属性
  {
    path: '/behaviorManage/operation-log/:meta_type',
    name: 'behaviorManageOperationLog',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOperationLog" */
      //   '@/views/masterDataSystem/OperationLog.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageOperationLog" */
        '@/views/behavior-manage/system-settings/operation-log/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '操作日志'
    }
  },

  // 劳务上限配置 列表
  {
    path: '/behaviorManage/service-limit/page',
    name: 'behaviorManageServiceLimitPage',
    component: () =>
      import(
        /*webpackChunkName:"behaviorManageServiceLimitPage" */
        '@/views/behavior-manage/system-settings/functional-module/service-limit/Page.vue'
      ),
    meta: {
      title: '劳务上限配置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  },

  // 劳务上限配置 列表
  {
    path: '/behaviorManage/service-limit/edit/:id',
    name: 'behaviorManageServiceLimitEdit',
    component: () =>
      import(
        /*webpackChunkName:"behaviorManageServiceLimitPage" */
        '@/views/behavior-manage/system-settings/functional-module/service-limit/Edit.vue'
      ),
    meta: {
      title: '新增配置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        },
        {
          title: '劳务上限配置',
          name: 'behaviorManageServiceLimitPage'
        }
      ]
    }
  },

  // 通讯录配置
  {
    path: '/behaviorManage/address-book/page',
    name: 'addressBookPage',
    component: () =>
      import(
        /*webpackChunkName:"addressBookPage" */
        '@/views/behavior-manage/system-settings/functional-module/address-book/Page.vue'
      ),
    meta: {
      title: '通讯录配置',
      breadcrumb: [
        {
          title: '移动端界面配置',
          name: 'behaviorManageMobileTerminalDeploy'
        }
      ]
    }
  },

  // 通讯录配置
  {
    path: '/behaviorManage/sales-achievement-statistics/page',
    name: 'SalesAchievementStatistics',
    component: () =>
      import(
        /*webpackChunkName:"addressBookPage" */
        '@/views/behavior-manage/system-settings/functional-module/sales-achievement-statistics/Page.vue'
      ),
    meta: {
      title: '销量达成统计配置',
      breadcrumb: [
        {
          title: '功能模块配置',
          name: 'functionModuleDeploy'
        }
      ]
    }
  }
]

export default systemSettingRouter
